export default __webpack_public_path__ + "static/media/achievements-title.5e7bb015.png";